import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import installationIcon from "../../../../../assets/new-product-detail-cats/header-icons/manufacturing-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getInstallationConstruction37Totals } from "../../../../../apis/Product/InstallationConstructionFlow37Api";

const InstallationConstruction37Icon = () => (
  <img src={installationIcon} alt="Installation and Construction Icon" width={76} height={76} />
);

const InstallationConstruction37Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalInstallationItem, setTotalInstallationItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getInstallationConstruction37Totals({
        productId,
        setTotals: setTotalInstallationItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`installation-construction-37-category ${className || ""}`}
      leftBoxProps={{
        icon: <InstallationConstruction37Icon />,
        title: t("INSTALLATION_CONSTRUCTION") || "Installation and Construction",
        description:
          t("INSTALLATION_CONSTRUCTION_DESC") ||
          "This section lists materials consumed during installation that are not part of the final product but are required for installation, such as protective plastic sheeting and pallets.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_37") || "Total for Flow 37",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalInstallationItem?.impact_totals || null,
        lastUpdated: totalInstallationItem?.updated_at
          ? formatDate(totalInstallationItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default InstallationConstruction37Header;

